import React, { useEffect, useState, useRef } from "react";
import BodyWrapper from "../../../components/Wrapper/BodyWrapper";
import Header from "../../../components/Header/Header";
import { BiSolidChevronDown } from "react-icons/bi";
import { Popover, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomers } from "../../../store/Slices/CustomerSlice";
import AuthInput from "../../../components/Input/AuthInput";
import {
  ErrorToast,
  SuccessToast,
  WarningToast,
} from "../../../utils/ShowToast";
import CustomerSelector from "../../../components/Selector/CustomerSelector";
import InoviceAddItem from "../../../components/InoviceAddItem/InoviceAddItem";
import SearchableTable from "../../../components/Tables/SearchableTable";
import { InvoiceColumns } from "../../../assets/Columns/InvocieColumns";
import AuthBtn from "../../../components/Buttons/AuthBtn";
import { CreateCustomerInvoiceApi } from "../../../ApiRequests";
import { fetchCustomerInvoice } from "../../../store/Slices/CustomerInvoiceSlice";
import InvoiceSelector from "../../../components/Selector/InvoiceSelector";
import { CustomerInvoiceColumns } from "../../../assets/Columns/CustomerInvoiceColumns";
import InvoiceEditItem from "../../../components/InoviceAddItem/InvoiceEditItem";

const CustomerViewInvoice = () => {
  const [SearchText, setSearchText] = useState("");

  const [SelectedCustomer, setSelectedCustomer] = useState("");
  const [SelectedInvoice, setSelectedInvoice] = useState("");

  const [OpenEditModal, setOpenEditModal] = useState(false);
  const [OpenDeleteModal, setOpenDeleteModal] = useState(false);
  const [Selected, setSelected] = useState("");

  const [itemId, setItemId] = useState("");
  const [name, setName] = useState("");
  const [net_vol, setNet_vol] = useState("");
  const [qty, setQty] = useState("");
  const [price, setPrice] = useState("");
  const [amount, setAmount] = useState("");
  const [NewItems, setNewItems] = useState([]);
  const itemCodeInputRef = useRef(null);
  const [Discount, setDiscount] = useState(0);
  const [CurDate, setCurDate] = useState("");

  const [CurrentItemQty, setCurrentItemQty] = useState("");

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    console.log("Closing popover...");
    setAnchorEl(null); // ✅ Ensures popover closes
  };
  const open = Boolean(anchorEl);
  const id = open ? "my-popover" : undefined;
  const ItemState = useSelector((state) => state.Products);
  const CustomerInvoices = useSelector((state) => state.CustomerInvoices);
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchCustomers());
  }, [dispatch]);

  useEffect(() => {
    if (SelectedCustomer) {
      setSelectedInvoice("");
      dispatch(fetchCustomerInvoice(SelectedCustomer._id));
    }
  }, [SelectedCustomer]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (!SelectedCustomer) WarningToast("Select Customer!");
    else if (!CurDate) WarningToast("Enter a valid Date");
    // else if (!qty || isNaN(qty)) WarningToast("Enter a valid Quantity");
    else {
      try {
        // const response = await AddStockStatsApi({
        //   invoice_no: invoiceNo,
        //   itemId: SelectedProduct._id,
        //   item_name: SelectedProduct.name,
        //   price: SelectedProduct.price,
        //   qty: Number(qty),
        //   total_amount: SelectedProduct.price * Number(qty),
        //   desc,
        //   date: CurDate,
        //   net_vol: SelectedProduct.net_vol,
        // });
        const response = await CreateCustomerInvoiceApi({
          customerId: SelectedCustomer._id,
          total_amount:
            Number(NewItems.reduce((total, item) => total + item.amount, 0)) -
            Number(Discount),
          discount: Number(Discount),
          items: NewItems,
          date: CurDate,
        });
        if (response.data.success) {
          SuccessToast("Invoice added successfully");
          dispatch(fetchStockStats());
        } else {
          ErrorToast(response.data.error?.msg);
        }
      } catch (err) {
        console.log(err);
        ErrorToast("Failed to add stock");
      }
    }
    setLoading(false);
  };

  return (
    <BodyWrapper>
      <Header
        title="Customers-Invoice"
        desc="Overview of your customer management"
      ></Header>
      <div className="flex flex-col gap-y-2">
        <CustomerSelector
          SelectedCustomer={SelectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
        />
        {SelectedCustomer && CustomerInvoices.data.length > 0 && (
          <InvoiceSelector
            activeTab={SelectedInvoice}
            setActiveTab={setSelectedInvoice}
          />
        )}
        {SelectedInvoice && (
          <div className="flex flex-col w-full">
            <div className="flex flex-col bg-subtle text-ink p-4 font-quicksand font-semibold mb-3 border border-line rounded-2xl gap-1">
              <div>
                Name: <span className="underline">{SelectedCustomer.name}</span>
              </div>
              <div>
                Address:{" "}
                <span className="underline">{SelectedCustomer.address}</span>
              </div>
              <div>
                Contact No:{" "}
                <span className="underline">{SelectedCustomer.contact}</span>
              </div>
              <div>
                Contact No:{" "}
                <span className="underline">{SelectedCustomer.contact}</span>
              </div>
              <div>
                Email:{" "}
                <span className="underline">{SelectedCustomer.email}</span>
              </div>
              <div>
                Invoice No: <span className="underline">{SelectedInvoice}</span>
              </div>
            </div>
            {SelectedInvoice && (
              <InoviceAddItem
                bgColor={saleType === "SALE" ? "bg-main" : "bg-[red]"}
                name={name}
                setName={setName}
                itemId={itemId}
                setItemId={setItemId}
                setPrice={setPrice}
                price={price}
                qty={qty}
                setQty={setQty}
                amount={amount}
                setAmount={setAmount}
                net_vol={net_vol}
                setNet_vol={setNet_vol}
                code={code}
                setCode={setCode}
                NewItems={NewItems}
                setNewItems={setNewItems}
              />
            )}
            {SelectedInvoice && (
              <SearchableTable
                setOpenEditModal={setOpenEditModal}
                setOpenDeleteModal={setOpenDeleteModal}
                setSelected={setSelected}
                SearchPlaceholder={"Search Item Name..."}
                SearchText={SearchText}
                setSearchText={setSearchText}
                CurrentData={
                  CustomerInvoices.data.find((dt) => dt._id === SelectedInvoice)
                    ?.items
                }
                //   CurrentData={CategoryState.data.filter((dt) =>
                //     SearchText === ""
                //       ? true
                //       : dt.title.toLowerCase().startsWith(SearchText.toLowerCase())
                //   )}
                Columns={CustomerInvoiceColumns}
                CurrentInvoice={CustomerInvoices.data.find(
                  (dt) => dt._id === SelectedInvoice
                )}
              />
            )}
          </div>
        )}
      </div>
    </BodyWrapper>
  );
};

export default CustomerViewInvoice;
